export const LINE_COLORS = [
  "#6248FF",
  "#371A32",
  "#00D2AF",
  "#F75200",
  "#FF63AF",
];
